module.exports = function (app, mod) {
  return "<div class=\"main dark\"></div>";
};